import { Box, Typography } from "@mui/material";
import React from "react";


const CustomerPage: React.FC = () => {
    return (
        <Box height="100vh" bgcolor="#FFFFFF">
            <Typography variant='h4' color='textPrimary'>Clientes</Typography>
            <Typography variant="subtitle1" color="textSecondary">Aqui você pode consultar as informações de seus clientes</Typography>
        </Box>
    );
}

export default CustomerPage;